(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-global"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DURATION = 300;

    document.querySelectorAll('.fc-faq-global').forEach((sectionEl) => {
      sectionEl.querySelectorAll('.fc-faq-global__item').forEach((itemEl) => {
        const summaryEl = itemEl.querySelector('.fc-faq-global__question');
        const wrapEl = itemEl.querySelector('.fc-faq-global__answer-wrap');
        if (!summaryEl || !wrapEl) return;

        let isAnimating = false;

        const syncAria = () => {
          summaryEl.setAttribute('aria-expanded', itemEl.open ? 'true' : 'false');
        };

        const openItem = () => {
          itemEl.open = true;
          syncAria();
          const scrollH = wrapEl.scrollHeight;
          wrapEl.style.maxHeight = scrollH + 'px';
          wrapEl.style.opacity = '1';

          setTimeout(() => {
            isAnimating = false;
            wrapEl.style.maxHeight = 'none';
          }, DURATION);
        };

        const closeItem = () => {
          wrapEl.style.maxHeight = wrapEl.scrollHeight + 'px';
          wrapEl.offsetHeight; /* force reflow */
          wrapEl.style.maxHeight = '0';
          wrapEl.style.opacity = '0';

          setTimeout(() => {
            itemEl.open = false;
            syncAria();
            isAnimating = false;
          }, DURATION);
        };

        syncAria();

        /* If open on load, set initial expanded styles */
        if (itemEl.open) {
          wrapEl.style.maxHeight = 'none';
          wrapEl.style.opacity = '1';
        }

        summaryEl.addEventListener('click', (e) => {
          e.preventDefault();
          if (isAnimating) return;
          isAnimating = true;

          if (itemEl.open) {
            closeItem();
          } else {
            openItem();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-cinewall-section-3"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSwipers() {
      document.querySelectorAll('.fc-cinewall3').forEach(function(section) {
        var swiperEl = section.querySelector('.fc-cinewall3__slider .swiper');
        var progressFill = section.querySelector('.fc-cinewall3__progress-fill');
        if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

        var totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;

        new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 32,
          grabCursor: true,
          breakpoints: {
            1024: {
              spaceBetween: 50,
            }
          },
          on: {
            init: function() { updateProgress(this, progressFill, totalSlides); },
            slideChange: function() { updateProgress(this, progressFill, totalSlides); },
            progress: function() { updateProgress(this, progressFill, totalSlides); }
          }
        });
      });
    }

    function updateProgress(swiper, fillEl, totalSlides) {
      if (!fillEl || totalSlides <= 0) return;
      var progress = swiper.progress;
      var minWidth = (1 / totalSlides) * 100;
      var width = minWidth + progress * (100 - minWidth);
      fillEl.style.width = Math.min(width, 100) + '%';
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSwipers);
    } else {
      initSwipers();
    }

    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        if (event.target.querySelector('.fc-cinewall3__slider .swiper')) {
          initSwipers();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-contact-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fc-contact-hero__btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      var href = btn.getAttribute('href');
      if (href && href.charAt(0) === '#') {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-homepage-section-7"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSwipers() {
      document.querySelectorAll('.fc-reviews').forEach(function(section) {
        var swiperEl = section.querySelector('.fc-reviews__swiper .swiper');
        var progressFill = section.querySelector('.fc-reviews__progress-fill');
        if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

        var totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;
        var prevBtn = section.querySelector('.fc-reviews__nav-btn--prev');
        var nextBtn = section.querySelector('.fc-reviews__nav-btn--next');

        new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 32,
          grabCursor: true,
          navigation: {
            prevEl: prevBtn,
            nextEl: nextBtn
          },
          on: {
            init: function() {
              updateProgress(this, progressFill, totalSlides);
            },
            slideChange: function() {
              updateProgress(this, progressFill, totalSlides);
            },
            progress: function() {
              updateProgress(this, progressFill, totalSlides);
            }
          }
        });
      });
    }

    function updateProgress(swiper, fillEl, totalSlides) {
      if (!fillEl || totalSlides <= 0) return;
      var progress = swiper.progress;
      var minWidth = (1 / totalSlides) * 100;
      var width = minWidth + progress * (100 - minWidth);
      fillEl.style.width = Math.min(width, 100) + '%';
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSwipers);
    } else {
      initSwipers();
    }

    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(event) {
        if (event.target.querySelector('.fc-reviews__swiper .swiper')) {
          initSwipers();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-our-studio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStudioSwipers() {
      if (typeof Swiper === 'undefined') return;

      document.querySelectorAll('.fc-studio').forEach(function (section) {
        var swiperEl = section.querySelector('.fc-studio__slider-wrap .swiper');
        var progressFill = section.querySelector('.fc-studio__progress-fill');
        var prevBtn = section.querySelector('.fc-studio__nav-prev');
        var nextBtn = section.querySelector('.fc-studio__nav-next');
        if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

        var totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;

        var instance = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          grabCursor: true,
          on: {
            init: function () {
              updateProgress(this, progressFill, totalSlides);
            },
            slideChange: function () {
              updateProgress(this, progressFill, totalSlides);
            }
          }
        });

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            instance.slidePrev();
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            instance.slideNext();
          });
        }
      });
    }

    function updateProgress(swiper, fillEl, totalSlides) {
      if (!fillEl || totalSlides <= 0) return;
      var width = ((swiper.activeIndex + 1) / totalSlides) * 100;
      fillEl.style.width = Math.min(width, 100) + '%';
    }

    function initAll() {
      initStudioSwipers();
      initStudioVideo();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    window.addEventListener('load', initAll);

    function initStudioVideo() {
      document.querySelectorAll('.fc-studio__media-desktop, .fc-studio__media-mobile').forEach(function (container) {
        var playBtn = container.querySelector('.fc-studio__play');
        var muteBtn = container.querySelector('.fc-studio__mute');
        var video = container.querySelector('.fc-studio__video-el');
        var poster = container.querySelector('.fc-studio__poster');
        if (!playBtn || !video || playBtn.dataset.bound) return;
        playBtn.dataset.bound = '1';

        function playVideo() {
          video.classList.add('is-playing');
          video.play();
          playBtn.style.display = 'none';
          if (muteBtn) muteBtn.classList.add('is-visible');
          if (poster) poster.classList.add('fc-studio__poster--hidden');
        }

        function pauseVideo() {
          video.pause();
          video.classList.remove('is-playing');
          playBtn.style.display = '';
          if (muteBtn) muteBtn.classList.remove('is-visible');
          if (poster) poster.classList.remove('fc-studio__poster--hidden');
        }

        playBtn.addEventListener('click', playVideo);

        video.addEventListener('click', pauseVideo);

        if (muteBtn) {
          muteBtn.addEventListener('click', function () {
            video.muted = !video.muted;
            muteBtn.classList.toggle('is-unmuted', !video.muted);
            muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
          });
        }
      });
    }

    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        if (event.target.querySelector('.fc-studio')) {
          initAll();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-preview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DESKTOP_BP = 768;
    var swiperInstances = [];

    function initPreviewSwipers() {
      if (typeof Swiper === 'undefined') return;
      if (window.innerWidth >= DESKTOP_BP) return;

      document.querySelectorAll('.fc-preview').forEach(function (section) {
        var swiperEl = section.querySelector('.fc-preview__slider .swiper');
        var progressFill = section.querySelector('.fc-preview__progress-fill');
        if (!swiperEl || swiperEl.classList.contains('swiper-initialized')) return;

        var totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;

        var instance = new Swiper(swiperEl, {
          slidesPerView: 'auto',
          spaceBetween: 32,
          grabCursor: true,
          on: {
            init: function () {
              updateProgress(this, progressFill, totalSlides);
            },
            slideChange: function () {
              updateProgress(this, progressFill, totalSlides);
            },
            progress: function () {
              updateProgress(this, progressFill, totalSlides);
            }
          }
        });

        swiperInstances.push(instance);
      });
    }

    function destroyPreviewSwipers() {
      swiperInstances.forEach(function (instance) {
        if (instance && instance.destroy) {
          instance.destroy(true, true);
        }
      });
      swiperInstances = [];
    }

    function handleResize() {
      if (window.innerWidth >= DESKTOP_BP) {
        destroyPreviewSwipers();
      } else if (swiperInstances.length === 0) {
        initPreviewSwipers();
      }
    }

    function updateProgress(swiper, fillEl, totalSlides) {
      if (!fillEl || totalSlides <= 0) return;
      var progress = swiper.progress;
      var minWidth = (1 / totalSlides) * 100;
      var width = minWidth + progress * (100 - minWidth);
      fillEl.style.width = Math.min(width, 100) + '%';
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initPreviewSwipers);
    } else {
      initPreviewSwipers();
    }

    window.addEventListener('load', initPreviewSwipers);
    window.addEventListener('resize', handleResize);

    if (Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        if (event.target.querySelector('.fc-preview__slider .swiper')) {
          initPreviewSwipers();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-product-details"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fc-accordion]').forEach(function(accordion) {
    var animDuration = 300;

    function closeItem(details) {
      var content = details.querySelector('.fc-product-details__item-content');
      content.addEventListener('transitionend', function handler() {
        content.removeEventListener('transitionend', handler);
        details.removeAttribute('open');
      });
      details.classList.add('fc-product-details__item--closing');
    }

    accordion.addEventListener('click', function(e) {
      var summary = e.target.closest('summary');
      if (!summary) return;
      var parentDetails = summary.parentElement;
      var isOpen = parentDetails.hasAttribute('open');

      e.preventDefault();

      accordion.querySelectorAll('details[open]').forEach(function(openItem) {
        if (openItem !== parentDetails) {
          closeItem(openItem);
        }
      });

      if (isOpen) {
        closeItem(parentDetails);
      } else {
        parentDetails.classList.remove('fc-product-details__item--closing');
        parentDetails.setAttribute('open', '');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSlider = (container) => {
      const track = container.querySelector('[data-fc-rp-slider]');
      const bar = container.querySelector('[data-fc-rp-slider-bar]');
      if (!track || !bar) return;

      const updateProgress = () => {
        const scrollWidth = track.scrollWidth - track.clientWidth;
        if (scrollWidth <= 0) return;
        const progress = track.scrollLeft / scrollWidth;
        const trackWidth = bar.parentElement.clientWidth;
        const barWidth = bar.clientWidth;
        const maxTranslate = trackWidth - barWidth;
        bar.style.transform = `translateX(${progress * maxTranslate}px)`;
      };

      const setBarWidth = () => {
        const cards = track.querySelectorAll('.fc-related-products__card');
        if (cards.length === 0) return;
        bar.style.width = `${(1 / cards.length) * 100}%`;
      };

      setBarWidth();
      updateProgress();
      track.addEventListener('scroll', updateProgress, { passive: true });
    };

    /* Initialise on page load for server-rendered content */
    document.querySelectorAll('.fc-related-products__container').forEach(initSlider);

    /* Re-initialise after product-recommendations fetches new HTML */
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          const container = node.querySelector
            ? node.querySelector('.fc-related-products__container') || (node.matches('.fc-related-products__container') ? node : null)
            : null;
          if (container) initSlider(container);
        });
      });
    });

    document.querySelectorAll('product-recommendations.fc-related-products__wrapper').forEach((el) => {
      observer.observe(el, { childList: true, subtree: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
